import { ReactElement } from 'react';
import { Text } from '~/components/typography';
import { useDialog } from '~/hooks';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

interface Props {
  target: ReactElement;
  copy?: {
    brandName?: string;
  };
}

export const DualBillingExplainerDialog = ({ target, copy }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);
  const brandName = copy?.brandName || 'Arcadia';

  return (
    <>
      {TargetComponent}
      <Dialog isOpen={isOpen} onDismiss={close} aria-label="Dual Billing Explainer">
        <Dialog.Header title="How do I save with two bills?" onClose={close} />
        <DialogSection title="Do I pay more with two bills?">
          <Text>
            Nope — with the solar credits <em>(see below)</em> you earn by being a community solar
            member. These two bills will add up to less than what you would have paid without
            community solar. Once your solar farm starts generating energy, you will see your
            savings stack up.
          </Text>
        </DialogSection>
        <DialogSection title="What is a solar credit?">
          {[
            `A solar credit represents the value of an amount of electricity generated by the solar farm you are connected to. Every month, ${brandName} applies the solar credits you’ve accumulated to your utility bill, guaranteeing that your energy costs are lower than what they would have been if you paid your utility for electricity directly.`,
          ]}
        </DialogSection>
        <DialogSection title="Why will I still receive a bill from my utility?">
          {[
            'Solar credits generally won’t offset 100% of the cost of the electricity you use in a month — you pay your utility the remainder.',
            'Additionally, your utility bill typically includes charges for transporting electricity from where it is generated to your residence. These charges will always be present, even if your solar credits offset 100% of your electricity usage.',
          ]}
        </DialogSection>
        <Dialog.FooterStacked primaryText="Close" onSubmit={close} />
      </Dialog>
    </>
  );
};
